import axios from "axios";
import { resetLogin } from "../redux/actions/login";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

const api = axios.create({
  baseURL: "https://api.100pay.org",
  headers: {
    "Content-Type": "application/json",
  },
});

export const EMethod = {
  GET: "GET",
  HEAD: "HEAD",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  CONNECT: "CONNECT",
  OPTIONS: "OPTIONS",
  TRACE: "TRACE",
  PATCH: "PATCH",
};

api.interceptors.request.use((req) => {
  const newRequest = req;
  const store = localStorage.getItem("state");
  const state = JSON.parse(store!);
  const { token } = state.login;

  if (token === "") {
    return req;
  }
  newRequest.headers.common["Authorization"] = `bearer ${token}`;
  
  return newRequest;
});

api.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response?.status === 401) {
      resetLogin();
      history.push("/auth/login");
      location.reload();
  }

  return Promise.reject(error);
});

export default api;
